/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/** Telemetry constants for Quick Menu used by model-layer code. */
export const HOMESCREEN_CAROUSEL_SCREEN_ID: string = "/screens/unityHome";
export const QUICK_MENU_API_ENDPOINT: string = "/v4/quickMenuShortcuts";
export const QUICK_MENU_DIAGNOSTIC_EVENT: string = "quick_menu_shortcuts";
